export default {
  placeholders: {
    first_name: 'Prenume',
    last_name: 'Nume de familie',
    email: 'Email',
    mobile_number: 'Număr de telefon',
  },
  labels: {
    exclusive_offers_via_email: 'Doresc să primesc oferte exclusive și noutăți prin email.',
  },
  buttons: {
    sign_up: 'Înregistrează-te',
  },
};
